module.exports = __webpack_public_path__ + "school/img/login.f7e8a09b.jpg";